import moment from "moment";
import { Show } from "shared/components";
import { capitalize, formatPhone, toMoney } from "shared/utils";
import { ContentTitle } from "views/applications-id-report/components/ContentTitle";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { CombinedIncome } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { incomeTypeMap } from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils";

export const SelfReportedStats = ({ income }: { income: CombinedIncome }) => {
  return (
    <ContentTitle
      title="Self-reported details"
      contentClassName="space-y-3"
      titleVariant="medium"
    >
      <Show if={income.type}>
        <KeyValue
          label="Income type"
          value={incomeTypeMap[income.type] || income.type}
        />
      </Show>
      {income.additional_data &&
      "company_name" in income.additional_data &&
      income.additional_data.company_name ? (
        <KeyValue
          label="Company name"
          value={income.additional_data.company_name}
        />
      ) : null}
      {income.additional_data &&
      "job_title" in income.additional_data &&
      income.additional_data.job_title ? (
        <KeyValue label="Job title" value={income.additional_data.job_title} />
      ) : null}
      <Show if={income.start_date}>
        <KeyValue
          label="Start date"
          value={moment(income.start_date).format("ll")}
        />
      </Show>
      <Show
        if={
          income.additional_data &&
          "supervisor" in income.additional_data &&
          Boolean(income.additional_data.supervisor?.first_name) &&
          Boolean(income.additional_data.supervisor?.first_name)
        }
      >
        <KeyValue
          label="Supervisor name"
          value={
            income.additional_data &&
            "supervisor" in income.additional_data &&
            income.additional_data.supervisor?.first_name &&
            income.additional_data.supervisor.last_name
              ? `${income.additional_data.supervisor.first_name} ${income.additional_data.supervisor.last_name}`
              : undefined
          }
        />
      </Show>
      <Show
        if={
          income.additional_data &&
          "supervisor" in income.additional_data &&
          income.additional_data.supervisor?.email
        }
      >
        <KeyValue
          label="Supervisor email"
          value={
            income.additional_data && "supervisor" in income.additional_data
              ? income.additional_data.supervisor?.email
              : ""
          }
        />
      </Show>
      <Show
        if={
          income.additional_data &&
          "supervisor" in income.additional_data &&
          income.additional_data.supervisor?.phone
        }
      >
        <KeyValue
          label="Supervisor phone"
          value={
            income.additional_data &&
            "supervisor" in income.additional_data &&
            income.additional_data.supervisor?.phone
              ? formatPhone(income.additional_data.supervisor.phone)
              : undefined
          }
        />
      </Show>
      <KeyValue
        label="Self-attested income"
        value={toMoney(income.amount_cents / 100)}
      />
      <KeyValue
        label="Pay frequency"
        value={capitalize(income.pay_period?.replace("_", "-") ?? "")}
      />
    </ContentTitle>
  );
};
